// src/mocks/handlers/funding/index.ts

import { fundingCommissionsHandler } from './commissionsHandler';
import { fundingCommissionsDownloadAllHandler } from './commissionsDownloadAllHandler';
import { fundingAdvanceDetailsHandler } from './advanceDetailsHandler';
import { fundingInvoicesDetailedHandler } from './invoicesDetailedHandler';
import { fundingInvoicesSummaryHandler } from './invoicesSummaryHandler';
import { fundingDocumentsHandler } from './documentsHandler';
import { fundingRevenuesHandler } from './revenuesHandler';
import { fundingDocumentsDownloadHandler } from './documentsDownloadHandler';
import { fundingRevenuesDownloadAllHandler } from './revenuesDownloadAllHandler';
import { fundingActivityCashMovementsHandler } from './activityCashMovementsHandler';
import { fundingActivityAdvanceMovementsHandler } from './activityAdvanceMovementsHandler';
import { fundingInvoicesCollectionsDetailsHandler } from './invoicesCollectionsDetailsHandler';
import { fundingInvoicesIssuedDetailsHandler } from './invoicesIssuedDetailsHandler';
import { cashMovementsDownloadPdfHandler } from './activityCashMovementsDownloadPdfHandler';
import { fundingInvoicesSummaryDownloadAllHandler } from './invoicesSummaryDownloadAllHandler';
import { fundingInvoicesDetailedDownloadAllHandler } from './invoicesDetailedDownloadAllHandler';
import { fundingCampaignDetailsHandler } from './campaignDetailsHandler';
import { chargeDetailsHandler } from './chargeDetailsHandler';

export const fundingHandlers = [
  fundingCommissionsHandler,
  fundingCommissionsDownloadAllHandler,
  fundingAdvanceDetailsHandler,
  fundingRevenuesHandler,
  fundingRevenuesDownloadAllHandler,
  fundingInvoicesSummaryHandler,
  fundingInvoicesSummaryDownloadAllHandler,
  fundingInvoicesDetailedHandler,
  fundingInvoicesDetailedDownloadAllHandler,
  fundingInvoicesCollectionsDetailsHandler,
  fundingInvoicesIssuedDetailsHandler,
  fundingDocumentsHandler,
  fundingDocumentsDownloadHandler,
  fundingActivityCashMovementsHandler,
  fundingActivityAdvanceMovementsHandler,
  cashMovementsDownloadPdfHandler,
  fundingCampaignDetailsHandler,
  chargeDetailsHandler,
];
